export const DASHBOARD_BASE = "/dashboard";

export const DASHBOARD_ROUTE_SEGMENTS = [
  "orders",
  "inventory",
  "messages",
  "yard-management",
  "shipments",
  "claims",

  "contracts",
  "invoices",
  "upload",
  "appointments",
  "manage-team",
  "notifications",
  "locations",
  "analytics",
  "transaction-audit",
  "resource-selection",
  "carrier-sourcing",
  "test-edi-upload",

];

export const YARD_MANAGEMENT_ROUTE_SEGMENTS = [
  "appointment-check-in",
];

/** True for /dashboard and /dashboard/... but not /dashboardsomething */
export function isDashboardPath(pathname) {
  return /^\/dashboard(\/|$)/.test(pathname);
}

export function isKnownDashboardRoute(pathname) {
  if (!isDashboardPath(pathname)) {
    return false;
  }

  const remainder = pathname.replace(/^\/dashboard\/?/, "");
  if (!remainder) {
    return true;
  }

  const segments = remainder.split("/").filter(Boolean);
  const [first, second, ...rest] = segments;

  if (!DASHBOARD_ROUTE_SEGMENTS.includes(first)) {
    return false;
  }

  if (first === "yard-management") {
    if (rest.length > 0) {
      return false;
    }
    return (
      second === undefined ||
      YARD_MANAGEMENT_ROUTE_SEGMENTS.includes(second)
    );
  }

  return segments.length === 1;
}

export function isUnknownDashboardRoute(pathname) {
  return isDashboardPath(pathname) && !isKnownDashboardRoute(pathname);
}

const AUTH_PATHS = ["/login", "/signup"];

/** Maps backend menu names (allowedMenus) to dashboard paths. */
export const MENU_ROUTE_MAP = {
  analytics: `${DASHBOARD_BASE}/analytics`,
  orders: `${DASHBOARD_BASE}/orders`,
  shipments: `${DASHBOARD_BASE}/shipments`,
  claims: `${DASHBOARD_BASE}/claims`,
  appointments: `${DASHBOARD_BASE}/appointments`,
  invoices: `${DASHBOARD_BASE}/invoices`,
  contracts: `${DASHBOARD_BASE}/contracts`,
  upload: `${DASHBOARD_BASE}/upload`,
  manageTeam: `${DASHBOARD_BASE}/manage-team`,
  locations: `${DASHBOARD_BASE}/locations`,
  resourceSelection: `${DASHBOARD_BASE}/resource-selection`,
  carrierSourcing: `${DASHBOARD_BASE}/carrier-sourcing`,
  "yard-management": `${DASHBOARD_BASE}/yard-management`,
  "transaction-audit": `${DASHBOARD_BASE}/transaction-audit`,
  // Standalone route OUTSIDE /dashboard/* (no sidebar/header chrome) — a Hostler's account only
  // ever holds HOSTLER:VIEW_GET/JOB_PATCH, which live on their own "yardHostler" backend menu
  // (see V275__add_hostler_role_and_privileges.sql), not the "yms" menu, specifically so a pure
  // Hostler account lands here instead of the full My Yard dashboard it has no other access to.
  yardHostler: "/yard-hostler",
};

export function getAllowedMenus() {
  try {
    const parsed = JSON.parse(localStorage.getItem("allowedMenus") || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function getFirstAllowedDashboardPath(fallback = `${DASHBOARD_BASE}/shipments`) {
  const allowed = getAllowedMenus();
  for (const menu of allowed) {
    const path = MENU_ROUTE_MAP[menu];
    if (path) return path;
  }
  return fallback;
}

export function getPostLoginRedirect(fromLocation, fallback = "/dashboard/shipments") {
  const pathname = fromLocation?.pathname;

  if (!pathname || typeof pathname !== "string" || !pathname.startsWith("/")) {
    return fallback;
  }

  if (AUTH_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`))) {
    return fallback;
  }

  if (isDashboardPath(pathname) && !isKnownDashboardRoute(pathname)) {
    return fallback;
  }

  return `${pathname}${fromLocation.search || ""}${fromLocation.hash || ""}`;
}
